import type { ChangeEventHandler } from 'react';
import React from 'react';
import styles from './dev-mode-picker.module.scss';

interface IDevModePickerProps {
  localStorageName: string;
  isDevMode: boolean;
}

export const DevModePicker: React.FC<IDevModePickerProps> = (props) => {
  const { localStorageName, isDevMode } = props;

  const handleClick: ChangeEventHandler<HTMLInputElement> = (e) => {
    localStorage.setItem(localStorageName, JSON.stringify(e.target.checked));
    window.location.reload();
  };

  return (
    <div className={styles.devMode}>
      <input type='checkbox' name='dev-mode' checked={isDevMode} onChange={handleClick} />
      <span>Dev Mode</span>
    </div>
  );
};
